import React from 'react'
import { Grid, Typography } from '@mui/material'
import Datetime from 'react-datetime'
import { StartDateSectionProps } from './types'

const StartDateSection: React.FC<StartDateSectionProps> = ({
    startDate,
    setStartDate,
    submitting,
    isValidStartDate,
    getCurrentLocale,
    label,
}) => {
    const handleChange = (newDate: any) => {
        if (typeof newDate === 'string') {
            setStartDate(new Date(newDate))
            return
        }

        setStartDate(new Date(newDate.format()))
    }

    return (
        <Grid container>
            <Grid size={{ xs: 12, sm: 2 }}>
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 500,
                        mb: 0.5,
                        display: 'block',
                    }}
                >
                    {label}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 10 }}>
                <Datetime
                    locale={getCurrentLocale()}
                    inputProps={{
                        disabled: submitting,
                        readOnly: true,
                    }}
                    closeOnSelect
                    onChange={handleChange}
                    value={startDate}
                    isValidDate={isValidStartDate}
                    utc={false}
                />
            </Grid>
        </Grid>
    )
}

export default StartDateSection
